export const formatNZD = (
  value: number | string | null | undefined,
  options: Intl.NumberFormatOptions = {}
) => {
  const numericValue = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numericValue)) return '—';

  // Use `en` locale to show explicit NZ$ prefix (less ambiguous than "$").
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'NZD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options
  }).format(numericValue);
};
